import { render, staticRenderFns } from "./team.vue?vue&type=template&id=55113e5a&scoped=true"
import script from "./team.vue?vue&type=script&lang=js"
export * from "./team.vue?vue&type=script&lang=js"
import style0 from "./team.vue?vue&type=style&index=0&id=55113e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55113e5a",
  null
  
)

export default component.exports